import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {CapacitySpectrum} from './capacity-spectrum.model';

export interface CapacitySpectrumState extends EntityState<CapacitySpectrum> {
}

@Injectable({providedIn: 'root'})
@StoreConfig({name: 'capacity-spectrum'})
export class CapacitySpectrumStore extends EntityStore<CapacitySpectrumState> {

  constructor() {
    super();
  }

}

